import { DUMMY_ERROR } from '../controller';
import { normalizeError } from './monitoring';
export function handleError({ store, actions, setProps, sentry, isSSR, }) {
    return (error) => {
        let errorId;
        const state = store && store.getState();
        console.error('--- error in commentsController ---', error);
        const shouldReportToSentry = error.message !== DUMMY_ERROR;
        if (sentry !== undefined) {
            errorId = shouldReportToSentry ? sentry.captureException(normalizeError(error)) : DUMMY_ERROR;
        }
        setProps({
            ...(state && { state }),
            ...(actions && actions),
            wcWorkerError: {
                isSSR,
                error: error.toString() !== '[object Object]' ? error.toString() : JSON.stringify(error),
                wasWorkerErrorCaptured: sentry !== undefined,
                ...(errorId && { errorId }),
            },
            isSSR,
        });
    };
}
//# sourceMappingURL=handle-error.js.map